import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { api, apiError } from "@/lib/api";
import { AdminDisputes } from "@/components/fleet/AdminDisputes";

const Driver = ({ d, onAction }) => {
  const p = d.profile;
  const blocked = d.status === "blocked";
  return (
    <div data-testid={`admin-driver-${d.id}`} className="ff-card p-4 flex flex-col gap-2">
      <div className="flex items-center justify-between gap-2">
        <span className="font-bold text-white truncate">{d.name || d.email}</span>
        {p?.verified ? <span className="ff-badge ff-badge-verified text-xs">NCC Verificato 🛡️</span> : <span className="ff-badge ff-badge-muted text-xs">Non verificato</span>}
      </div>
      <span className="text-sm text-[#CBD5E1]">{d.email} • {d.role === "admin" ? "Admin" : "Autista"}{blocked ? " • BLOCCATO" : ""}</span>
      {p && <span className="text-sm text-[#CBD5E1]">Licenza {p.license_number || "—"} • {p.license_city || "—"} • Doc: {p.doc_check?.status || (p.has_document ? "caricato" : "assente")}</span>}
      {d.role !== "admin" && (
        <div className="grid grid-cols-2 gap-2 mt-1">
          <button type="button" data-testid={`admin-approve-${d.id}`} disabled={!p?.has_document || p?.doc_check?.status === "recognized"} onClick={() => onAction(d.id, "approve")} className="ff-btn-secondary !min-h-[48px] text-sm border-[#3B82F6]">Approva licenza</button>
          <button type="button" data-testid={`admin-block-${d.id}`} onClick={() => onAction(d.id, blocked ? "unblock" : "block")} className={`ff-btn-secondary !min-h-[48px] text-sm ${blocked ? "" : "border-red-500 text-red-300"}`}>{blocked ? "Sblocca" : "Blocca"}</button>
        </div>
      )}
    </div>
  );
};

export const AdminSheet = ({ open, onClose }) => {
  const [drivers, setDrivers] = useState([]);
  const load = useCallback(() => api.get("/admin/drivers").then((r) => setDrivers(r.data)).catch((e) => toast.error(apiError(e))), []);

  useEffect(() => {
    if (open) load();
  }, [open, load]);

  const onAction = async (id, action) => {
    try {
      await api.post(`/admin/drivers/${id}`, { action });
      toast.success("Aggiornato");
      load();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent data-testid="admin-sheet" className="ff-glass-panel w-full sm:max-w-lg overflow-y-auto">
        <SheetHeader className="text-left">
          <SheetTitle className="ff-display text-2xl font-extrabold text-white">Pannello Admin</SheetTitle>
          <SheetDescription className="text-[#CBD5E1]">{drivers.length} account registrati. Approva licenze non riconosciute o blocca account.</SheetDescription>
        </SheetHeader>
        <AdminDisputes open={open} />
        <div className="mt-6 flex flex-col gap-3">{drivers.map((d) => <Driver key={d.id} d={d} onAction={onAction} />)}</div>
      </SheetContent>
    </Sheet>
  );
};
